import { useState } from "react";
import Navbar from "../components/Navbar";
import "../styles/Executives.css";
import Footer from "../components/Footer";
import AmakaCelestine from "../assets/images/Current Executives/Amaka Celestina  Ofodile.jpg";
import ChidiOchinanwata from "../assets/images/Current Executives/Chief Chidi Ochinanwata.jpg";
import VictorIloUshi from "../assets/images/Current Executives/DR. VICTOR ILO USHI.jpg";
import ChyAgbayi from "../assets/images/Current Executives/Dr. Mrs. Chy Agbayi.jpg";
import ChukAkubuilo from "../assets/images/Current Executives/Dr.(Chief) Chuk Akubuilo.jpg";
import GodwinUgwuoke from "../assets/images/Current Executives/Hon. Godwin Ugwuoke.jpg";
import NikkiOgbodo from "../assets/images/Current Executives/Lolo Nikki Ogbodo.jpg";
import TkOmeh from "../assets/images/Current Executives/Mrs. Tk Omeh.jpg";
import ClaraObyEneh from "../assets/images/Current Executives/Ms Clara Oby Eneh.jpg";
import RommyOkabuonye from "../assets/images/Current Executives/Sir Rommy Okabuonye.jpg";
import OzorRichard from "../assets/images/Current Executives/Ozor Richard.jpg";

const CurrentExutives = () => {
  const [modal, setModal] = useState(false);
  const [name, setName] = useState("");
  const [image, setImage] = useState();
  const [title, setTitle] = useState("");
  const [desc, setDesc] = useState("");

  const showInfoModal = (name, image, title, desc) => {
    setName(name);
    setDesc(desc);
    setTitle(title);
    setModal(true);
    setImage(image);
    document.getElementById("description").innerHTML = desc;
  };

  return (
    <>
      <Navbar />
      <section class="executives">
        <div class="heading">
          <h2>
            Meet Our Current <span>Executives</span>
          </h2>
          <p>
            Meet our current executives, a dynamic team of visionaries committed
            to driving positive change and fostering unity among Enugu State
            diaspora. With a diverse range of skills, experiences, and a shared
            passion for service, our executives lead with integrity, compassion,
            and dedication.
          </p>
        </div>

        {/* EXECUTIVE CARDS  */}
        <div class="executivesCards">
          <div class="card">
            {/* onclick="showInfoModal(`Dr. Mrs. Chy Agbayi`, `assets/images/Current Executives/Dr. Mrs. Chy Agbayi.jpg`, `NATIONAL PRESIDENT`)"  */}
            <img src={ChyAgbayi} alt="" />
            <div class="content">
              <h3>Dr. Mrs. Chy Agbayi</h3>
              <p id="position">NATIONAL PRESIDENT</p>
            </div>
          </div>
          <div
            class="card"
            onClick={() =>
              showInfoModal(
                `Amaka Celestina Ofodile`,
                AmakaCelestine,
                `Vice President`,
                `<ul>Amaka Celestina Ofodile. MSN Ed; RN, CBIS. served Enugu USA in the following capacities <li>The vice president of the Enugu State Association USA. 2022 to 2024.</li> <li>Electoral returning officer 2014.</li> <li>Member conference planning 2016, 2017, 2018, 2019, 2022, 2023, 2024.</li> <li> NATIONAL PRO 2018 - 2022</li> <li>Chief Nursing Office 2014 - 2018</li> <li>Assistant PRO 2014- 2018.</li> In this not-for-profit association of Enugu indigenes in America, she volunteers to help provide medical missions to populations of individuals living in Nigeria. Focusing Fon the healthcare situation in Enugu State, bringing access to healthcare to urban and rural Enugu people living in Nigeria.</ul> <span>Amaka C. Ofodile earned her master’s degree in nursing education from Grand Canyon University Arizona with a research focus on Diabetes prevention and a healthy lifestyle. She is a great advocate of stroke awareness and prevention and treatment. She earned her Bachelor of Science in Nursing (BSN) from Winston Salem State University, North Carolina. Ofodile is a board-certified Brain Injury Specialist (CBIS). Amaka C. Ofodile is a member of Sigma Theta Tau International (Sgima) Global Nursing Excellence- Nu Upsilon chapter and Sigma Global Nursing Excellence PHI KAPPA chapter Very active in the American Nurses Association(ANA) and North Carolina Nurses Association (NCNA) Chair mentorship and grant writing committee NNANC</span> <span>Amaka C. Ofodile is a servant leader, public speaker, innovator, and advocate who believes in better health for all. Amaka C. Ofodile brings over seventeen years of leadership experience to Enugu USA.</span> <ul><li>PRESIDENT NATIONAL ASSOCIATION OF NIGERIAN NURSES IN NORTH AMERICA 2023 - 2024</li> <li>President of the Nigerian Nurses Association North Carolina INC, USA (NNANC).</li> <li>Present Founding member NNANC Board member NNANC</li> <li>Present Chair leadership Committee of NNANC.</li> <li>Present NANNNA Vice President 2022-2023</li> <li>Founder, executive director, and president of Weserve Healthcare INC.</li>  <li>President of Nigerian Women Association Raleigh USA.</li> <li>Present President and founder of Queen Rebecca Anichebe Scholarship Education Foundation ISIGWU UMANA Enugu Ngeria</li></ul> <span>Rooted in the vision of the benefits of community service to humanity and passionate about serving humanity through academic and professional growth and holding a master's degree in nursing education. A coach, mentor, educator, and charge RN Clinical Nurse four works at WakeMed Health and Hospital in Raleigh, North Carolina, as a registered nurse in an acute rehabilitation hospital. She has worked in primary care, acute care, and long-term care. Amaka C. Ofodile provides quality care to her patients and supports healthcare quality initiatives that earned her multiple Daisy Awards nominations and promotions.</span> <span>Ofodile leadership role climbed the ladder as an entrepreneur, innovator, advocator who Believes in worshiping the Lord, a Catholic religious faith, and serves in the church as the financial secretary of the Igbo Catholic Community in Raleigh, North Carolina. A visionary and mission-focused leader routed in community service, Catholic outreach volunteer, meals, and Wheels volunteers to provide these populations of individuals with some of their daily needs. She was spiritually grounded based on her upbringing and⁰ personal growth.</span> <span>Outside work and in th social/ professional groups, Ofodile is married to a supportive husband and has two incredible children. She enjoys spending quality time with family and friends and loves to dance, travel, read, watch movies, walk, and cook. She is a negotiator buzzing with positive energy to stabilize and maintain an environment promoting life. Amaka C. Ofodile dedicated her academic and professional life to her late mother, Queen Rebecca Anichebe, who raised her, and her seven siblings because her father died so early. She can not tell her story without her late aunt, Mrs. Caroline Okofor, and her elder brother, HRH, Igwe Emmanuel Anichebe, who supported her academic and growth process during her childhood. These individuals believed in me so much, leading to me trusting myself to succeed in everything she does, dusting off failures, and embarking on new beginnings. She also believes that all things are possible with God, and serving humanity is serving God to put a smile on humanity's faces by promoting better health for all is Amaka C. Ofodile’s passion.</span>`
              )
            }
          >
            <img
              src={AmakaCelestine}
              alt=""
              style={{
                //padding: "0px 80px",
                backgroundColor: "white",
                //border: "1px solid gray",
              }}
            />
            <div class="content">
              <h3>Amaka Celestina Ofodile</h3>
              <p id="position">Vice President</p>
            </div>
          </div>
          <div
            class="card"
            onClick={() =>
              showInfoModal(
                `Ozor Richard Igwegbu (Ekeweze II na Akama Oghe)`,
                OzorRichard,
                `Assistant Provost [National Executive]`,
                `Founder and Chief Encouragement Officer (CEO), Unix Training Academy`
              )
            }
          >
            <img src={OzorRichard} alt="" />
            <div class="content">
              <h3>Ozor Richard Igwegbu (Ekeweze II na Akama Oghe)</h3>

              <p id="position">PRO, Enugu USA</p>
            </div>
          </div>
          <div class="card">
            {/* onClick={() => showInfoModal(`Chief Chidi Ochinanwata`, `assets/images/Current Leadership/Chief Chidi Ochinanwata.jpg`, `Assistant Public Relations Officer`)} */}
            <img src={ChidiOchinanwata} alt="" />
            <div class="content">
              <h3>Chief Chidi Ochinanwata</h3>
              <p id="position">Assistant Public Relations Officer</p>
            </div>
          </div>

          <div
            class="card"
            onClick={() =>
              showInfoModal(
                `Ozo, Sir, Chief, Dr. Chukwudi (Chuck) Akubuilo MBA, D.B.A, Ed.`,
                ChukAkubuilo,
                `Financial Secretary `,
                `Dr. Chukwudi Akubuilo is an educator, as well as an entrepreneur. He teaches United States History, Business and Education courses at the high school and college levels. Dr. Akubuilo is the founder and the Executive Officer of Okuli Group, LLC, a consulting firm, specializing in business and education. Dr. Akubuilo maintains memberships in many philanthropic and social organizations.`
              )
            }
          >
            <img src={ChukAkubuilo} alt="" />
            <div class="content">
              <h3>
                Ozo, Sir, Chief, Dr. Chukwudi (Chuck) Akubuilo MBA, D.B.A, Ed.
              </h3>
              <p id="position">Financial Secretary</p>
            </div>
          </div>

          <div class="card">
            {/* onclick="showInfoModal(`Dr. Victor Ilo USHI`, `assets/images/Current Executives/DR. VICTOR ILO USHI.jpg`, `Secretary General EUSA [National Executive]`)"  */}
            <img src={VictorIloUshi} alt="" />
            <div class="content">
              <h3>Dr. Victor Ilo USHI</h3>
              <p id="position">Secretary General EUSA [National Executive]</p>
            </div>
          </div>

          <div class="card">
            {/* onclick="showInfoModal(`Lolo Nikki Ogbodo`, `assets/images/Current Executives/Lolo Nikki Ogbodo.jpg`, `Assistant Secretary General, EUSA[National Executive]`)"  */}
            <img src={NikkiOgbodo} alt="" />
            <div class="content">
              <h3>Lolo Nikki Ogbodo</h3>
              <p id="position">
                Assistant Secretary General, EUSA[National Executive]
              </p>
            </div>
          </div>
          <div class="card">
            {/* onclick="showInfoModal(`Hon. Ms Clara Oby Eneh.`, `assets/images/Current Executives/Ms Clara Oby Eneh.jpg`, `EnuguUsa Treasurer`)"  */}
            <img src={ClaraObyEneh} alt="" />
            <div class="content">
              <h3>Hon. Ms Clara Oby Eneh.</h3>
              <p id="position">EnuguUsa Treasurer</p>
            </div>
          </div>
          <div class="card">
            {/* onclick="showInfoModal(`Dr. Mrs. Tk Omeh`, `assets/images/Current Executives/Mrs. Tk Omeh.jpg`, `Assistant Treasurer`)"  */}
            <img src={TkOmeh} alt="" />
            <div class="content">
              <h3>Dr. Mrs. Tk Omeh</h3>
              <p id="position">Assistant Treasurer</p>
            </div>
          </div>
          <div class="card">
            {/* onclick="showInfoModal(`Hon. Godwin Ugwuoke`, `assets/images/Current Executives/Hon. Godwin Ugwuoke.jpg`, `Provost - Enugu USA`)"  */}
            <img src={GodwinUgwuoke} alt="" />
            <div class="content">
              <h3>Hon. Godwin Ugwuoke</h3>
              <p id="position">Provost - Enugu USA</p>
            </div>
          </div>
          <div class="card">
            {/* onclick="showInfoModal(`Sir Pascal Mba`, `assets/images/Current Executives/Sir Rommy Okabuonye.jpg`, `Assistant Provost [National Executive]`)"  */}
            <img src={RommyOkabuonye} alt="" />
            <div class="content">
              <h3>Sir Rommy Okabuonye</h3>
              <p id="position">Assistant Provost [National Executive]</p>
            </div>
          </div>
         
        </div>
      </section>

      {/* EXECUTIVES DETAILS OVERLAY  */}
      <section class={modal ? "executivesDetails" : "hide"}>
        <div class="executivesDetailsWrap">
          <div class="executiveOverlay">
            <p class="close" onClick={() => setModal(false)}>
              x
            </p>
            <img src={image} alt="" />
            <div class="content">
              <div class="head">
                <h3>{name}</h3>
                <p>{title}</p>
              </div>
              <p id="description" class="description"></p>
              <div class="contact">
                <h3>Contact Me</h3>
                <div class="icons">
                  <i class="bi bi-facebook"></i>
                  <i class="bi bi-whatsapp"></i>
                  <i class="bi bi-twitter-x"></i>
                  <i class="bi bi-instagram"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default CurrentExutives;
